<template>
  <!-- CREATE ACCOUNT FORM -->
  <div class="container mt--6 pb-5">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary border-0 mb-0">
          <div class="card-body px-lg-5 py-lg-4">
            <div class="text-center mb-lg-4 mb-md-4 mb-3">
              <strong>Create Account</strong>
            </div>
            <form role="form" @submit.prevent="handleSubmit">
              <base-input
                label="Email"
                class="mb-3"
                type="email"
                placeholder="Enter your email address"
                v-model="email"
                spellcheck="false"
                required
              ></base-input>

              <base-input
                label="Password"
                class="mb-3"
                type="password"
                placeholder="Enter your password"
                v-model="password"
                required
              ></base-input>

              <base-input
                label="Confirm Password"
                class="mb-3"
                type="password"
                placeholder="Re-enter your password"
                v-model="repassword"
                required
              ></base-input>

              <base-checkbox class="mb-3" v-model="termsCheckbox">
                I accept the&nbsp;
                <router-link to="/terms" target="_blank"
                  >Art Grab Terms of Use</router-link
                >.
              </base-checkbox>

              <div class="create-account-errors" role="alert">
                {{ formError || createAccountError }}
              </div>

              <div class="text-center">
                <base-button
                  type="primary"
                  :loading="loading"
                  nativeType="input"
                  block
                  class="my-4"
                  size="lg"
                  >CREATE ACCOUNT</base-button
                >Already have an account?&nbsp;
                <router-link to="/login">Log in here.</router-link>
              </div>
            </form>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <div>
              <small>Artists, please log in via the Artist Portal.</small>
            </div>
            <a :href="portalUrl">
              <small>Go to the Artist Portal</small>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "create-account",
  metaInfo() {
    return {
      title: "Create Account - Art Grab",
      meta: [
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: `summary_large_image`,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: `Art Grab : Create Account`,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: `Create an Art Grab customer account. Artists, please visit myportal.artgrab.co to create an account.`,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: "https://i.imgur.com/gp9AfzO.jpeg",
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `https://artgrab.co/createaccount`,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `Art Grab : Create Account`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `Create an Art Grab customer account. Artists, please visit myportal.artgrab.co to create an account.`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: "https://i.imgur.com/gp9AfzO.jpeg",
        },
        {
          vmid: "description",
          property: "description",
          content: `Create an Art Grab customer account. Artists, please visit myportal.artgrab.co to create an account.`,
        },
      ],
    };
  },
  data() {
    return {
      email: "",
      password: "",
      repassword: "",
      termsCheckbox: false,
      loading: false,
      formError: "",
    };
  },
  methods: {
    handleSubmit: function () {
      this.loading = true;
      const { email, password, repassword, termsCheckbox } = this;

      if (email.length >= 5) {
        if (password.length >= 8) {
          if (password == repassword) {
            if (termsCheckbox) {
              this.formError = "";
              const plan = this.$route.query.plan;
              const asset_id = this.$route.query.id;
              const pro_file_id = this.$route.query.proFileId;

              this.$store
                .dispatch("createAccount", { email, password }, plan)
                .then(() => {
                  if (this.isLoggedIn) {
                    if (plan === "pro_file") {
                      this.$router.push({
                        path: "/purchase",
                        query: {
                          plan: plan,
                          proFileId: pro_file_id,
                          id: asset_id,
                        },
                      });
                    } else {
                      this.$router.push({
                        path: "/purchase",
                        query: { plan: plan, id: asset_id },
                      });
                    }
                  }
                  this.loading = false;
                });
            } else {
              this.formError =
                "Please accept the terms by checking the checkbox.";
              this.loading = false;
            }
          } else {
            this.formError = "Password and confirm password do not match.";
            this.loading = false;
          }
        } else {
          this.formError = "Password length needs to be at least 8 characters.";
          this.loading = false;
        }
      } else {
        this.formError = "Please enter a valid email address.";
        this.loading = false;
      }
    },
    clearForm() {
      this.$store.commit("createAccountError", "");
      this.formError = "";
      this.email = "";
      this.password = "";
      this.repassword = "";
      this.termsCheckbox = false;
      this.loading = false;
    },
  },
  computed: {
    ...mapState(["createAccountError", "isLoggedIn", "referral"]),
    portalUrl() {
      let portalUrl = process.env.VUE_APP_PORTAL_URL;
      if (this.referral) {
        portalUrl += "?referral=" + this.referral;
      }
      return portalUrl;
    },
  },
  mounted() {
    this.$store.commit("setLayout", "simple-layout");
    this.clearForm();
  },
};
</script>

<style lang="scss" scoped>
.create-account-errors {
  font-size: 0.875rem;
  color: red;
  text-align: center;
}
</style>
